import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { useMemo } from 'react';
import Loading from '~/components/loading/Loading';
import ProviderGroupSummaryTotalVerified from '../actions/book/ProviderGroupSummaryTotalVerified';
import useVerifiedBreakdown from '~/apps/smartsend/hooks/use-verified-breakdown';

interface props {
  item: SmartSendItemApiModel;
  children: React.ReactNode;
}

const ItemBreakdown: React.FC<props> = (props) => {
  const items = useMemo(() => [props.item], [props.item]);

  const { loading, breakdown } = useVerifiedBreakdown({
    provider: props.item.Service.Provider,
    accountId: props.item.Service.AccountId,
    items
  });

  if (loading) {
    return <Loading />;
  }

  if (breakdown) {
    return <ProviderGroupSummaryTotalVerified breakdown={breakdown} currencyCode={props.item.CurrencyCode} />;
  }

  return <>{props.children}</>;
};

export default ItemBreakdown;
